import { Account } from '@/models/account';

function shouldShowContentfulBanner(account: Account | null, currentPath: string): boolean {
  // Banner is only shown to basic parents
  if (!account || !account.isBasic() || !account.isParent()) {
    return false;
  }

  // We deliberately hide the banner on these routes to keep the user focused
  const excludedRoutes = ['/registration', '/upgrade', '/bh-benefits', '/job-post'];
  const isExcludedRoute = excludedRoutes.some((route) => currentPath.startsWith(route));

  if (isExcludedRoute) {
    return false;
  }

  return true;
}

export default shouldShowContentfulBanner;
